<template>
  <div class="confft-container">
    <div
      v-for="i in items"
      :key="i"
      class="confftpc"
    ></div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'AnimConfetti',
  mixins: [format_mix],
  data() {
    this.items = [...new Array(13).keys()]
    return {}
  },
}
</script>
<style lang="scss" scoped>
.confft-container {
  --cff-height: 24rem;
  --cff-duration: 1000ms;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: var(--cff-height);
  width: 100%;
  top: 0;
  left: 0;
}
@keyframes Rain {
  from {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  to {
    transform: translateY(var(--cff-height));
  }
}

.confftpc {
  position: absolute;
  width: 10px;
  height: 30px;
  top: 0;
  opacity: 0;
  background: var(--clr-primary);
}

.confftpc:nth-child(odd) {
  background: var(--clr-mtt);
}
.confftpc:nth-child(4n-7) {
  background: var(--clr-orange);
}

.confftpc:nth-child(1) {
  left: 7%;
  transform: rotate(-40deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.182);
  animation-duration: 1116ms;
}
.confftpc:nth-child(2) {
  left: 14%;
  transform: rotate(4deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.161);
  animation-duration: 1076ms;
}
.confftpc:nth-child(3) {
  left: 21%;
  transform: rotate(-51deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.481);
  animation-duration: 1103ms;
}
.confftpc:nth-child(4) {
  left: 28%;
  transform: rotate(61deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.334);
  animation-duration: 708ms;
}
.confftpc:nth-child(5) {
  left: 35%;
  transform: rotate(-52deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.302);
  animation-duration: 776ms;
}
.confftpc:nth-child(6) {
  left: 42%;
  transform: rotate(38deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.18);
  animation-duration: 1168ms;
}
.confftpc:nth-child(7) {
  left: 49%;
  transform: rotate(11deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.395);
  animation-duration: 1200ms;
}
.confftpc:nth-child(8) {
  left: 56%;
  transform: rotate(49deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.14);
  animation-duration: 887ms;
}
.confftpc:nth-child(9) {
  left: 63%;
  transform: rotate(-72deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.149);
  animation-duration: 805ms;
}
.confftpc:nth-child(10) {
  left: 70%;
  transform: rotate(10deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.351);
  animation-duration: 1059ms;
}
.confftpc:nth-child(11) {
  left: 77%;
  transform: rotate(4deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.307);
  animation-duration: 1132ms;
}
.confftpc:nth-child(12) {
  left: 84%;
  transform: rotate(42deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.464);
  animation-duration: 776ms;
}
.confftpc:nth-child(13) {
  left: 91%;
  transform: rotate(-72deg);
  animation: Rain var(--cff-duration) infinite ease-out;
  animation-delay: calc(1ms * var(--cff-duration) * 0.429);
  animation-duration: 818ms;
}
.confftpc:nth-child(even) {
  z-index: 1;
}

.confftpc:nth-child(4n) {
  width: 5px;
  height: 12px;
  animation-duration: 2000ms;
}
.confftpc:nth-child(3n) {
  width: 3px;
  height: 10px;
  animation-duration: 2500ms;
  animation-delay: calc(1ms * var(--cff-duration));
}
</style>
